export default {"src":"/_next/static/media/hf.7d5ac7d5.svg","height":541,"width":497,"blurWidth":0,"blurHeight":0};